import { createContext } from 'react';
import { IUser } from '../types/reducers/authReducer';

export type PermissionsType = {
    general: string[];
    scoped: Array<{
        scope: string;
        entity_id: number;
        permissions: string[];
    }>;
};


export const UserContext = createContext<{
    user: IUser | null,
    permissions: PermissionsType["general"],
    scopedPermissions: PermissionsType["scoped"],
    workspaceRole: string | null
}>({
    user: null,
    permissions: [],
    scopedPermissions: [],
    workspaceRole: null
});
